import React from "react";

function MineIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="2"
      fill="none"
      viewBox="0 0 11 2"
    >
      <path
        fill="#DE2242"
        d="M9.905 1.9h-8.8c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h8.8c.5 0 .9.4.9.9s-.4.9-.9.9z"
      ></path>
    </svg>
  );
}

export default MineIcon;
